import { createReducer, createAsyncThunk } from '@reduxjs/toolkit';

import { AdsByIngredient } from '../types';
import { RootState } from '.';
import { chicoryFetcher, fetchUrlFormatter, getValidPubs } from '../utils';

const initialAdsByIngredient: AdsByIngredient = [];

// Thunk
export const fetchAdsByIngredient = createAsyncThunk<
  AdsByIngredient,
  number,
  { state: RootState }
>('FETCH_ADS_BY_INGREDIENT', async (limit, { getState }) => {
  const state = getState();

  const pubs = getValidPubs({
    selectedPubs: state.pubs.selectedPubs,
    availablePubs: state.pubs.availablePubs,
  });
  const path = '/reporting/ads/ingredient';

  try {
    if (state.dateRange.from === null || state.dateRange.to === null) {
      throw new Error('Date range in store is unexpectedly null.');
    }
    const data = await chicoryFetcher(
      fetchUrlFormatter({
        path: path,
        from: state.dateRange.from,
        to: state.dateRange.to,
        pubs: pubs,
        limit: limit,
      })
    ).then((response) => response.json());
    return data;
  } catch (error) {
    console.error('fetchAdsByIngredient error.', error);
  }
});

export const adsByIngredientReducer = createReducer<AdsByIngredient>(
  initialAdsByIngredient,
  (builder) => {
    builder.addCase(fetchAdsByIngredient.fulfilled, (state, action) => {
      return action.payload;
    });
  }
);
